import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../../i18n';
import { FALLBACK_IMAGE as FALLBACK } from '../../lib/api';
import { Img } from '../Img';
import { collectionCover } from '../../lib/collectionCovers';

/** Le collezioni come griglia che va a capo (2/3/4 colonne): una fila tagliata
 *  al bordo si legge come un errore. Titolo sotto l'immagine, niente velatura.
 *  Dove c'e' uno scatto d'ambiente (ASSETS A-10, vedi collectionCovers) la card e' a tutta foto;
 *  altrimenti il packshot del feed, intero su carta. */
export const CollectionsRail = ({ collections }) => {
  const { t } = useLang();
  // 12 si divide per 2, 3 e 4 colonne: nessuna card resta sola nell'ultima fila
  const items = (collections || []).filter((c) => !c.b2b).slice(0, 12);
  if (!items.length) return null;

  return (
    <section data-testid="home-collections" className="py-20 md:py-32">
      <div className="wrap">
        <div className="mb-12 grid gap-7 md:grid-cols-[1fr_auto] md:items-end">
          <div>
            <h2 className="max-w-[18ch] text-[30px] leading-[1.06] md:text-[40px] lg:text-[52px]">{t('home.collectionsTitle')}</h2>
            <p className="prosa mt-7 max-w-[52ch]">{t('home.collectionsLead')}</p>
          </div>
          <Link to="/collezioni" data-testid="home-all-collections" className="btn btn-line shrink-0">
            {t('common.allCollections')}
            <ArrowUpRight size={15} strokeWidth={2} />
          </Link>
        </div>

      <ul
        data-testid="collections-rail"
        className="grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 md:gap-x-6 lg:grid-cols-4"
      >
        {items.map((c) => (
          <li key={c.slug}>
            <Link
              to={`/collezioni/${c.slug}`}
              data-testid={`home-collection-${c.slug}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-carta-2">
                {collectionCover(c.slug) ? (
                  /* Scatto d'ambiente gia' ritagliato 3:4: a tutta card. Niente
                     onError, e' un asset nostro: cosi' resta lazy (vedi Img). */
                  <Img
                    src={collectionCover(c.slug)}
                    alt={c.name}
                    width={600}
                    aspectRatio={3 / 4}
                    sizes="(max-width:768px) 50vw, (max-width:1024px) 33vw, 25vw"
                    className="img-zoom h-full w-full object-cover"
                  />
                ) : (
                  <Img
                    src={c.images?.[0] || FALLBACK}
                    alt={c.name}
                    sizes="(max-width:768px) 50vw, (max-width:1024px) 33vw, 25vw"
                    onError={(e) => {
                      e.currentTarget.src = FALLBACK;
                    }}
                    /* Foto prodotto quadrate su fondo bianco: intere e in alto
                       (object-cover in 3:4 tagliava un quarto, es. il manico
                       della tazza Victionary), multiply fonde il bianco nella
                       carta. */
                    className="img-zoom h-full w-full object-contain object-top p-6 mix-blend-multiply"
                  />
                )}
              </div>
              <h3 className="mt-4 font-display text-[18px] leading-snug transition-colors group-hover:text-marsala md:text-[24px]">
                {c.name}
              </h3>
              {c.story?.claim && (
                <p className="mt-1 max-w-[32ch] text-[14px] leading-snug text-inchiostro/70">
                  {c.story.claim}
                </p>
              )}
            </Link>
          </li>
        ))}
      </ul>
      </div>
    </section>
  );
};
